<template>
    <div>
        <div class="container">
            <div id="btn-home" class="col-md-12 mt-3 mb-4 d-flex justify-content-end btn-home">
                <button type="button" class="btn btn-outline-main" @click="changePage('home')">
                    <i class="fas fa-home-lg-alt"></i> Inicio
                </button>
            </div>
            <div id="div-modal-cxc" class="d-flex justify-content-center">
                <div id="div-cxc" class="card w-100">
                    <div class="card-header text-white h4 text-center" style="background: #43517A">
                        <strong class="text-uppercase">Movimientos de productos</strong>
                    </div>
                    <div class="card-body w-100">
                        <div class="row d-flex mx-0 px-0">
                            <div class="col-xl-12 mt-3 mb-4 table-responsive" id="content-timelinetable">
                                <table class="table text-xxs table-bordered border-main text-center align-middle"
                                    style="font-size: 12px;">
                                    <caption class="py-0 my-0"></caption>
                                    <thead>
                                        <tr class="text-white border-white text-center text-uppercase"
                                            style="background: #43517A; vertical-align: middle">
                                            <th scope="col">Categoría</th>
                                            <th scope="col">Sub Categoría</th>
                                            <th scope="col">Nombre</th>
                                            <th scope="col">Marca</th>
                                            <th scope="col">Modelo</th>
                                            <th scope="col">Serie</th>
                                            <th scope="col">Stock</th>
                                            <th scope="col">Acciones</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr v-if="cpData.length == 0">
                                            <td colspan="13" class="text-center">No hay registros</td>
                                        </tr>
                                        <tr v-for="(item, index) in cpData" :key="index">
                                            <td>{{ item.sub_sub.subategorie.categorie.name }}</td>
                                            <td>{{ item.sub_sub.subategorie.name }}</td>
                                            <td>{{ item.sub_sub.name }}</td>
                                            <td>{{ item.brand }}</td>
                                            <td>{{ item.model }}</td>
                                            <td>{{ item.serie }}</td>
                                            <td>{{ item.stock }}</td>
                                            <td>
                                                <div class="text-center d-flex justify-content-center">
                                                    <button class="btn btn-sm a-primary text-white"
                                                        @click="mtdModalActivos(item.id)">
                                                        <i class="fas fa-regular fa-eye"></i>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <!-- Paginación -->
                        <div v-if="cpData.length > 0" class="d-flex justify-content-center mb-2">
                            <nav aria-label="Page navigation example">
                                <ul class="pagination mb-1">
                                    <li class="page-item">
                                        <a class="page-link page" href="javascript:void(0)"
                                            @click="backPage">Anterior</a>
                                    </li>
                                    <li v-if="limitedStepPagination[0] !== 1" class="page-item">
                                        <a :class="selectPage === 1 ? 'page-link active' : 'page-link'"
                                            href="javascript:void(0)" @click="selectedPage(1)">1</a>
                                    </li>
                                    <li v-if="limitedStepPagination[0] > 2" class="page-item disabled">
                                        <span class="page-link">...</span>
                                    </li>

                                    <li v-for="(item, index) in limitedStepPagination" :key="index" class="page-item">
                                        <a :class="selectPage === item ? 'page-link active' : 'page-link'"
                                            href="javascript:void(0)" @click="selectedPage(item)">{{ item }}
                                        </a>
                                    </li>
                                    <li v-if="limitedStepPagination[limitedStepPagination.length - 1] < stepPagination.length - 1"
                                        class="page-item disabled">
                                        <span class="page-link">...</span>
                                    </li>
                                    <li v-if="limitedStepPagination[limitedStepPagination.length - 1] !== stepPagination.length"
                                        class="page-item">
                                        <a :class="selectPage === limitedStepPagination.length + 2 ? 'page-link active' : 'page-link'"
                                            href="javascript:void(0)" @click="selectedPage(stepPagination.length)">{{
                                                stepPagination.length }}
                                        </a>
                                    </li>
                                    <li class="page-item">
                                        <a class="page-link page" href="javascript:void(0)"
                                            @click="nextPage">Siguiente</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <cModalActivos :title="modalActivos.title" :boo_modal="modalActivos.modal_form" :payload="payload"
            :id_activo="modalActivos.activo_id" @closeModalActivos="closeModalActivos" @mtd_modal="mtd_modal" />
        <cModalMovimientoActivos :title="modal.title" :boo_modal="modal.modal_form" :item="modal.item"
            :activo_id="modal.activo_id" @closeModal="closeModal" @mtdDataEmit="mtdDataEmit" />
    </div>
</template>

<script>
import { mapActions } from "vuex";
import cModalActivos from "@/components/Logistica/modals/Movimientos/cModalActivos.vue";
import cModalMovimientoActivos from "@/components/Logistica/modals/Movimientos/cModalMovimientosActivos.vue";

export default {
    name: "c-logistica-pages-movimientos",
    components: {
        cModalActivos,
        cModalMovimientoActivos
    },
    data() {
        return {
            dataProductos: [],
            modalActivos: {
                title: '',
                modal_form: false,
                activo_id: 0,
            },
            payload: [],
            modal: {
                title: '',
                modal_form: false,
                item: {},
                activo_id: 0
            },
            //Paginacion
            dataShow: [],
            page: 0,
            selectPage: 1,
            stepPagination: [],
            totalPagesToShow: 4,
        }
    },
    computed: {
        cpData() {
            return this.dataShow;
        },
        limitedStepPagination() {
            const totalPages = this.stepPagination.length;
            const currentPage = this.selectPage;
            let startPage = 1;
            let endPage = totalPages;
            if (totalPages > this.totalPagesToShow) {
                const halfPagesToShow = Math.floor(this.totalPagesToShow / 2);

                if (currentPage > halfPagesToShow) {
                    startPage = currentPage - halfPagesToShow;
                    endPage = currentPage + halfPagesToShow - 1;

                    if (endPage > totalPages) {
                        endPage = totalPages;
                        startPage = totalPages - this.totalPagesToShow + 1;
                    }
                } else {
                    endPage = this.totalPagesToShow;
                }
            }
            return Array.from({
                length: endPage - startPage + 1,
            },
                (_, i) => startPage + i
            );
        },
    },
    watch: {
        selectPage() {
            this.calculateData(7);
        },
    },
    created() {
        this.mtdGetData();
    },
    methods: {
        ...mapActions(["get", "post"]),
        mtd_modal(item, id) {
            this.modal.title = 'Mover de almacen';
            this.modal.modal_form = true;
            this.modal.item = item;
            this.modal.activo_id = id;
        },
        mtdGetData: function () {
            this.get({
                url: this.$store.getters.get__url + "/logistics/indexMovementActives",
                token: this.$store.getters.get__token,
            }).then((response) => {
                this.dataProductos = response.data;
                this.calculateData(6);
            }).catch((error) => {
                console.log(error);
            });
        },
        mtdModalActivos: function (payload) {
            this.get({
                url: this.$store.getters.get__url + "/logistics/indexActivos/" + payload,
                token: this.$store.getters.get__token,
            }).then((response) => {
                this.modalActivos.title = 'Lista de activos';
                this.modalActivos.modal_form = true;
                this.payload = JSON.parse(response.data.activos.location || '[]');
                this.modalActivos.activo_id = Number(response.data.id);
            })
        },
        closeModalActivos: function () {
            this.modalActivos = {
                title: '',
                modal_form: false,
            }
            this.payload = []
        },
        closeModal: function () {
            this.modal = {
                title: '',
                modal_form: false,
                item: {},
                activo_id: 0
            }
        },
        mtdDataEmit(id) {
            this.mtdModalActivos(id);
        },
        changePage(page) {
            this.$emit("returnHome", page);
        },
        //Paginación
        calculateData(items) {
            if (!this.dataProductos || !this.dataProductos.length) {
                return (this.dataShow = []);
            }
            let filteredData = this.dataProductos;
            let indexInitial = this.selectPage;
            let totalPages = Math.ceil(filteredData.length / items);
            this.stepPagination = Array.from({
                length: totalPages,
            },
                (_, index) => index + 1
            );
            let startIndex = (indexInitial - 1) * items;
            let endIndex = startIndex + (items - 1);
            this.dataShow = filteredData.slice(startIndex, endIndex + 1);
            this.count = this.count + 1;
        },
        backPage() {
            this.selectPage = this.selectPage > 1 ? this.selectPage - 1 : 1;
        },
        nextPage() {
            this.selectPage =
                this.selectPage < this.stepPagination.length ?
                    this.selectPage + 1 :
                    this.stepPagination.length;
        },
        selectedPage(page) {
            this.selectPage = page;
        },
    }
}
</script>